function formatDateString(date) {
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const day = date.getDate();
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const seconds = date.getSeconds();
	return `${year}-${month < 10 ? '0' : ''
		}${month}-${day} ${hours}:${minutes}:${seconds}`;
}

module.exports = {
	formatDateString,
};
